var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 23,
    height: 23,
    rx: 5,
    ry: 5,
    transform: "translate(-6.3 15.21) rotate(-45)",
    fill: "#82368c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 7.85,
    cy: 15.11,
    r: 1.52,
    fill: "#f59e00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.21,
    cy: 15.31,
    r: 1.52,
    fill: "#f59e00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.56,
    cy: 15.31,
    r: 1.52,
    fill: "#f59e00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestIcon);
export default __webpack_public_path__ + "static/media/TestIcon.3df5af3d7cfb0634df3cae1d55f7c7be.svg";
export { ForwardRef as ReactComponent };